module.exports = __webpack_public_path__ + "static/media/cities.2d873c03.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/travel/cities.jpg
// module id = 751
// module chunks = 0